module.exports = __webpack_public_path__ + "static/media/man_wangfang.5947c5fc.png";